// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||
class ExtendProductOffer extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();
        
        const referenceId = productForm.id.value;
        const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = meta.product.type;
        
        this.params = {
            referenceId,
            price,
            category
        }
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = true;
        this.config.isHeroPage = document.querySelector('.hero-product');
        
        this.productForm = productForm;
        this.addToCartButton = addToCartButton;
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
        
        this.bindEvents();
        this.style.display = 'block';
        
        if (!this.config.pdpOfferEnabled || this.config.isHeroPage) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.params, () => {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 250);
        });
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {
        
        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
        
    }
    
    modalDone() {
        // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        this.addToCartButton.click();
        // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        // If variable set to true, dispatches Extend side cart integration to run after adding to cart via pdp
        if (this.config.dispatchSideCart) window.setTimeout(() => {
            initCartOffer();
        }, 500);
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const quantityEl = this.productForm.querySelector('[name="quantity"]');
        const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;
        
        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.modalOfferEnabled,
            done: this.modalDone.bind(this)
        });
    }
    
    handleVariantChange() {
        // Flicker prevention
        
        this.params.referenceId = this.productForm.id.value;
        this.params.price = meta.product.variants.filter(variant => variant.id == this.params.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.params);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    }
}
if (!customElements.get('extend-offer'))
    customElements.define('extend-offer', ExtendProductOffer);

function getOfferAnchor() {
    let anchor = document.querySelector('.product__container').querySelector('[data-product-price]').parentElement;
    if (anchor.nextElementSibling.classList.contains('affirm-as-low-as')) {
        anchor = anchor.nextElementSibling;
    }
    return anchor;
}
/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer() {
    try {
        if ((meta.page.pageType != 'product' || !meta.product))
            throw new ExtendError("Extend Product Offer - The current page is not a product page");
    } catch (err) {
        console.warn(err.message);
        return;
    }
    
    const productFormSelector = 'product-form form[action="/cart/add"]';
    const addToCartButtonSelector = 'button[name="add"]';
    
    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    // Create offer and render it
    const extendOffer = new ExtendProductOffer(productForm, addToCartButton);
    
    const offerAnchor = getOfferAnchor();
    if (offerAnchor) {
        offerAnchor.after(extendOffer);
    } else {
        productForm.before(extendOffer);
    }

    // Sticky add to cart
    const stickyAddToCart = extendOffer.config.isHeroPage ? document.querySelector(`hero-nav-bar ${addToCartButtonSelector}`) : document.querySelector(`.sticky-product-actions__actions ${addToCartButtonSelector}`);
    if (stickyAddToCart) {
        stickyAddToCart.addEventListener('click', (e) => {
            extendOffer.handleAddToCart.bind(extendOffer)(e);
        });
    }
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||

const cartOfferTag = 'extend-cart-offer';
var cart;
var init = false;

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    SPEnabled
} = getConfiguration();

let type, selectors;
if (meta.page.pageType === 'cart' && (cartOfferEnabled || cartSPEnabled)) {
    selectors = {
        cartContainer: 'cart-items',
        cartRowItem: 'tr.cart-item', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__media a', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__name', // Title anchor element for the product
        cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: 'dl .product-option', // Each warranty metadata item we want to remove.
        offerAnchor: '.cart-item__details', // Container where the offer will be appended
        metadataContainer: 'dl', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: 'quantity-input', // Wrapper for quantity input and buttons
        lineItemRemove: 'cart-remove-button'
    }
    type = 'main';
} else if (sideCartOfferEnabled) {
    selectors = {
        cartContainer: 'cart-drawer-items',
        cartRowItem: 'tr.cart-item', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__media a', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__name', // Title anchor element for the product
        cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: 'dl .product-option', // Each warranty metadata item we want to remove.
        offerAnchor: '.cart-item__details', // Container where the offer will be appended
        metadataContainer: 'dl', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: 'quantity-input', // Wrapper for quantity input and buttons
        lineItemRemove: 'cart-remove-button'
    }
    type = 'side';
}

if (type === undefined || selectors === undefined) {
    throw new ExtendError('No cart type detected');
}

class ExtendCartOffer extends HTMLElement {
    
    constructor(referenceId, category, price, quantity, type) {
        super();
        this.params = {
            referenceId,
            category,
            price,
            quantity
        }
        this.type = type;
        
        this.config = getConfiguration();
    }
    
    connectedCallback() {
        if (!this.canDisplayOffer()) {
            return;
        }
        
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }                    
                    document.dispatchEvent(new Event('extend.plan-added'));
                });
            }
        });
    }
    
    canDisplayOffer() {
        return (this.type === 'main' && this.config.cartOfferEnabled) || (this.type === 'side' && this.config.sideCartOfferEnabled);
    }
}
if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

const cartItems = document.querySelector(selectors.cartContainer);

cartItems.refreshCartItems = function() {
    fetch(`${routes.cart_url}`).then((response) => response.text())
    .then((state) => {
        const updatedContent = getSectionInnerHTML(state, '.drawer__inner');
        document.querySelector('.drawer__inner').innerHTML = updatedContent;
    }).catch((err) => {
        throw new ExtendError(err.message);
    }).finally(() => {
        initCartOffer();
    });
}

function createWarrantyOffer(lineItemElement, index) {
    if (!cartOfferEnabled) return;
    
    let cartItem = cart.items[index];
    if (!cartItem) {
        throw new ExtendError(`Cart Item not found at index ${index}`);
    }

    const referenceId = cartItem.variant_id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);
    
    let anchor = lineItemElement.querySelector(selectors.offerAnchor);
    
    if (!anchor) {
        throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`);
    }
    
    let extendOffer = lineItemElement.querySelector(cartOfferTag);
    
    // If there's already an offer element, check that the properties match what we are trying to create
    // If they do not match, or the warranty is already in cart, remove the offer
    if (extendOffer) {
        if (extendOffer.params.referenceId !== referenceId ||
            extendOffer.params.quantity !== quantity ||
            extendOffer.params.price !== price ||
            extendOffer.params.category !== category ||
            warrantyAlreadyInCart
        ) {
            extendOffer.remove();
            // If they do match and the warranty is not already in the cart, do not create a new offer
        } else {
            return;
        }
        // If there is no offer element, but the warranty is already in cart, do not create a new offer
    } else if (warrantyAlreadyInCart) {
        return;
    }
    
    let newExtendOffer = new ExtendCartOffer(referenceId, category, price, quantity, type);
    
    anchor.append(newExtendOffer); // append, prepend, after, before
}

function styleWarrantyLineItem(lineItemElement, index) {
    const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
    title.style.pointerEvents = 'none';
    title.innerText = 'Extend Protection Plan';
    
    const image = lineItemElement.querySelector(selectors.cartRowItemImage);
    
    if (image) {
        image.style.pointerEvents = 'none';
    } else {
        console.error(`EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`)
    }
    
    const warrantyMetadata = lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta);
    
    let originalMetaClass;
    if (warrantyMetadata?.length) {
        originalMetaClass = warrantyMetadata[0].className;
        warrantyMetadata.forEach(each => {
            each.remove();
        });
    }
    
    if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper)) {
        lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
            each.style.opacity = '75%';
            each.style.pointerEvents = 'none';
        });
    }
    
    let contentContainer = lineItemElement.querySelector(selectors.metadataContainer)
    let warrantyProductData;
    let warrantyTermData;
    const cartItem = cart.items[index];
    
    if (cartItem.options_with_values && cartItem.options_with_values[1]) { // Finds the ref id string in the product info string and replaces with an empty string
        let regexReplace = cartItem.options_with_values[0].value.match(/\-\d{5,}/g);
        warrantyProductData = cartItem.options_with_values[0].value.replace(regexReplace, '');
        warrantyTermData = cartItem.options_with_values[1].value;
    } else {
        warrantyProductData = cartItem.properties.Product;
        warrantyTermData = cartItem.properties.Term;
    }
    
    // For category offers, fetch title by filtering through cart for warranted product refId
    if (warrantyProductData === "Covered Product") {
        const coveredProductId = cartItem.properties['_Extend.ProductId'];
        warrantyProductData = cart.items.find((item) => item.id.toString() == coveredProductId).title;
    }
    
    // Appends Product and Term metadata
    if (lineItemElement.querySelector(selectors.metadataContainer)) {
        let warrantyProductName = document.createElement('div');
        
        warrantyProductName.className = `${originalMetaClass} extend-warranty-info extend-warranty-info-product`;
        warrantyProductName.innerHTML = `<dt>Product: </dt> <dd>${warrantyProductData}</dd>`;
        
        let warrantyProductTerm = document.createElement('div')
        warrantyProductTerm.className = `${originalMetaClass} extend-warranty-info extend-warranty-info-term`;
        warrantyProductTerm.innerHTML = `<dt>Term: </dt> <dd>${warrantyTermData}</dd>`;
        
        // Only append the metadata if it's not already there
        if (!lineItemElement.querySelector('.extend-warranty-info')) {
            contentContainer.append(warrantyProductName, warrantyProductTerm)
        }
    }
}

function renderOrStyleCart() {
    const cartContainer = document.querySelector(selectors.cartContainer);
    
    if (!cartContainer) {
        throw new ExtendError(`Invalid cart container selector: ${selectors.cartContainer}`);
    }
    
    cartContainer.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }
        
        const lowerCaseTitle = title.innerHTML.toLowerCase();
        
        if (lowerCaseTitle.includes('extend protection')) {
            styleWarrantyLineItem(lineItemElement, index);
        } else {
            createWarrantyOffer(lineItemElement, index);
        }
    });
}

function normalizeItems(callback) {
    const normalizationOpts = {
        balance: cartBalancingEnabled, 
        balanceCart: cartBalancingEnabled,
        isSPSupported: cartSPEnabled,
        callback
    };

    if (SPEnabled) {
        ExtendShopify.updateExtendLineItems(normalizationOpts);
    } else {
        ExtendShopify.normalizeCart(normalizationOpts, callback);
    }
}

function refreshCart() {
    if (type === 'side') {
        cartItems.refreshCartItems();
    } else if (type === 'main') {
        location.reload();
    } else {
        window.location.reload();
    }
}

function verifyCartOffers() {
    verifyExtend();
    
    let error = '';
    if (!selectors) error = `Cart selectors are empty\n`;
    
    if (!type) error += `Cart type not defined\n`;
    
    if (error.length > 0) {
        throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
    }
}

function initEventListeners() {
    document.addEventListener('extend.plan-added', () => {
        refreshCart();
    });

    document.addEventListener('extend.cart-updated', () => {
        initCartOffer();
    });
    
    init = true;
}


function initCartOffer() {

    verifyCartOffers();
    
    try {
        if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
            throw new ExtendError('Cannot initialize cart offers - not a cart page');
        }
    } catch (err) {
        console.warn(err.message);
        return;
    }
    
    if (!init) initEventListeners();
    
    normalizeItems((err, data) => {
        cart = data?.cart;
        if (err) {
            throw new ExtendError(err.message);
        }
        
        if (data?.updates) {
            refreshCart();
        } else {
            renderOrStyleCart();
        }
    });
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        writeLogsEnabled: false,
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: true,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();
        
        // Get params from URL
        const params = (new URL(document.location)).searchParams;
        
        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
        ? params.get('leadToken')
        : params.get('leadtoken');
        
        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

function getCart() {
    return fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(e => e.json());
}

// Integration init
window.addEventListener('DOMContentLoaded', () => {
    try {
        const storeId = '933d30ae-b07e-411f-a4f9-cc9ba4613592';
        const environment = 'production';
        
        window.Extend.config({ storeId, environment});
        
        const config = getConfiguration();
        
        if (config.aftermarketModalEnabled)
            initAftermarket();
        
        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();
        
        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer('main');
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
});